export const getStyled = (theme) => ({
  ticketHeader: {
    display: 'flex',
    width: '100%',
    background: theme.custom.colors.total,
    flex: 'none',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    height: '65px',

    '@media (maxWidth: 600px)': {
      flexWrap: 'wrap',
      height: 'max-content',
    },
  },
  button: {
    color: theme.custom.colors.text,
    borderRadius: '50%',
    padding: 0,
    margin: 0,
    marginLeft: 1,
    height: 40,
    minWidth: 0,
    width: 40,
    alignSelf: 'center',

    '&:hover': {
      backgroundColor: theme.palette.mode === 'light' ? '#bdbdbd' : '#2C3E4E',
    },
  },
  icon: {
    transform: 'translateX(25%)',
  },
});
